var fspAvail = 'all';
var fspPrice = 'all';

function fspFilter(type, value, btn) {
  var group = btn.parentNode;
  var siblings = group.getElementsByTagName('button');
  for (var i = 0; i < siblings.length; i++) {
    siblings[i].classList.remove('fsp-filter-btn--active');
  }
  btn.classList.add('fsp-filter-btn--active');

  if (type === 'availability') fspAvail = value;
  if (type === 'price') fspPrice = value;

  fspApply();
}

function fspApply() {
  var grids = document.querySelectorAll('.fsp-grid');

  for (var g = 0; g < grids.length; g++) {
    var grid = grids[g];
    var products = grid.querySelectorAll('.fsp-product');
    var arr = [];
    for (var p = 0; p < products.length; p++) arr.push(products[p]);

    // Toon/verberg per product op beschikbaarheid
    for (var i = 0; i < arr.length; i++) {
      var prod = arr[i];
      var avail = prod.getAttribute('data-available') === 'true';
      var show = true;
      if (fspAvail === 'available' && !avail) show = false;
      if (fspAvail === 'sold' && avail) show = false;
      prod.style.display = show ? '' : 'none';
    }

    // Sorteren op prijs
    if (fspPrice !== 'all') {
      arr.sort(function(a, b) {
        var pa = parseInt(a.getAttribute('data-price') || 0, 10);
        var pb = parseInt(b.getAttribute('data-price') || 0, 10);
        return fspPrice === 'asc' ? pa - pb : pb - pa;
      });
      for (var j = 0; j < arr.length; j++) grid.appendChild(arr[j]);
    }
  }
}